import type React from "react";
import { useChannels } from "@/hooks/channel/useChannels";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { ChannelTable } from "./components/ChannelTable";
import { CreateChannelDialog } from "./components/CreateChannelDialog";
import { useState } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Skeleton } from "@/components/ui/skeleton";

const ChannelManagementPage: React.FC = () => {
	const { channels, loading, error } = useChannels();
	const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

	if (loading) {
		return (
			<div className="space-y-4">
				<div className="flex justify-between items-center">
					<Skeleton className="h-8 w-48" />
					<Skeleton className="h-10 w-32" />
				</div>
				<Skeleton className="h-[400px] w-full" />
			</div>
		);
	}

	if (error) {
		return (
			<Alert variant="destructive">
				<AlertDescription>
					チャンネル一覧の取得に失敗しました。
				</AlertDescription>
			</Alert>
		);
	}

	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h1 className="text-3xl font-bold">チャンネル管理</h1>
				<Button onClick={() => setIsCreateDialogOpen(true)}>
					<Plus className="h-4 w-4 mr-2" />
					チャンネルを作成
				</Button>
			</div>

			<ChannelTable channels={channels} />

			<CreateChannelDialog
				open={isCreateDialogOpen}
				onOpenChange={setIsCreateDialogOpen}
			/>
		</div>
	);
};

export default ChannelManagementPage;
